import { trackConversion, trackEvent } from '../../lib/analytics';

export const LandingFooter = () => {
    return (
        <footer id="contact" className="bg-pacces-ebony text-white pt-32 pb-8 font-sans relative overflow-hidden border-t border-pacces-gold/10">
            {/* Background Accent */}
            <div className="absolute top-0 right-0 w-1/2 h-full bg-white/5 -skew-x-12 translate-x-1/2 pointer-events-none"></div>

            <div className="max-w-7xl mx-auto px-6 relative z-10">
                <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 mb-24">
                    <div className="flex flex-col justify-start pt-8 lg:pt-24 lg:pl-16">
                        <img src="/logo/Logo-Pacces-Advogados-Branco.png" alt="Pacces Advogados" className="h-16 lg:h-24 w-auto self-center lg:self-start" />
                    </div>

                    <div className="space-y-12 text-center lg:text-right flex flex-col items-center lg:items-end">
                        <div className="space-y-6 flex flex-col items-center lg:items-end">
                            <div className="flex items-center gap-3 text-pacces-gold">
                                <span className="text-[12px] uppercase font-bold tracking-[0.3em]">Unidade São Paulo</span>
                                <span className="material-symbols-outlined text-xl">location_on</span>
                            </div>
                            <div className="space-y-1">
                                <a href="tel:+551123690371" onClick={() => trackConversion('sp', 'phone')} className="text-2xl md:text-3xl font-serif hover:text-pacces-gold transition-colors">(11) 2369-0371</a>
                                <div className="text-sm text-stone-400 font-light flex items-center justify-center lg:justify-end gap-2">
                                    WhatsApp: <a href="https://wa.me/5511969241378" target="_blank" rel="noopener noreferrer" onClick={() => trackConversion('sp', 'whatsapp')} className="hover:text-pacces-gold transition-colors">(11) 96924-1378</a>
                                    <span className="material-icons text-[14px] text-pacces-gold">phone_iphone</span>
                                </div>
                            </div>
                            <address className="text-base text-stone-500 not-italic leading-relaxed font-light text-center lg:text-right">
                                Av. Ordem e Progresso, 157, Sala 408<br />
                                Barra Funda - São Paulo - SP
                            </address>
                            <a
                                href="https://wa.me/5511969241378?text=Olá,%20gostaria%20de%20falar%20com%20a%20unidade%20de%20São%20Paulo"
                                target="_blank"
                                rel="nofollow"
                                onClick={() => trackConversion('sp', 'whatsapp')}
                                className="inline-flex items-center gap-3 bg-transparent border border-pacces-gold/30 text-pacces-gold px-6 py-3 text-[12px] font-bold uppercase tracking-[0.2em] rounded-sm hover:bg-pacces-gold hover:text-pacces-ebony transition-all duration-300"
                            >
                                Falar no WhatsApp <span className="material-icons text-sm">east</span>
                            </a>
                        </div>

                        <div className="pt-10 border-t border-white/5 w-full flex flex-col sm:flex-row items-center justify-center lg:justify-between gap-8">
                            <a
                                href="https://www.instagram.com/paccesadvogados/"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => trackEvent('social_click', { rede: 'instagram' })}
                                className="inline-flex items-center gap-3 text-[12px] font-bold uppercase tracking-[0.2em] text-stone-500 hover:text-pacces-gold transition-colors"
                            >
                                <span className="w-10 h-10 rounded-full border border-pacces-gold/30 flex items-center justify-center text-pacces-gold">
                                    <span className="material-icons text-lg">photo_camera</span>
                                </span>
                                @paccesadvogados
                            </a>
                        </div>

                        <div className="pt-10 border-t border-white/5 w-full flex justify-center lg:justify-end">
                            <div className="flex flex-col lg:flex-row-reverse items-center gap-4 lg:gap-6">
                                <div className="w-14 h-14 rounded-none border border-pacces-gold/30 flex items-center justify-center text-pacces-gold">
                                    <span className="material-symbols-outlined">mail</span>
                                </div>
                                <div className="text-center lg:text-right">
                                    <div className="text-[12px] uppercase text-stone-500 font-bold tracking-[0.3em] mb-1">E-mail Corporativo</div>
                                    <a href="mailto:contato@paccesadvogados.com.br" onClick={() => trackConversion('sp', 'email')} className="text-base lg:text-lg font-serif break-all hover:text-pacces-gold transition-colors">contato@paccesadvogados.com.br</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Barra final no padrão ApexDev: copyright | crédito NO CENTRO | links.
                    Uma linha só a partir de xl; abaixo disso empilha centralizado. */}
                <div className="pt-6 pb-24 xl:pb-6 border-t border-white/5 grid grid-cols-1 xl:grid-cols-[1fr_auto_1fr] items-center gap-6">
                    <p className="text-center xl:text-left text-[12px] text-stone-600 uppercase tracking-[0.2em] font-medium">
                        © {new Date().getFullYear()} Pacces Advogados.<span className="hidden sm:inline xl:hidden 2xl:inline"> Excelência Institucional.</span>
                    </p>
                    <a href="https://devapex.us" target="_blank" rel="noopener noreferrer" className="justify-self-center flex items-center gap-3 whitespace-nowrap opacity-70 hover:opacity-100 transition-opacity">
                        <span className="text-[12px] text-stone-500 uppercase tracking-[0.2em] font-medium">Developed by</span>
                        <img src="/apexdev_linear_white.svg" alt="ApexDev" className="h-5 w-auto shrink-0" />
                    </a>
                    <nav className="flex flex-wrap justify-center xl:justify-end gap-x-8 xl:gap-x-6 gap-y-3 text-[12px] font-bold uppercase tracking-[0.3em] xl:tracking-[0.2em] text-stone-500">
                        <a id="footer-link-about" className="hover:text-pacces-gold transition-colors" href="/#about">Sobre</a>
                        <a id="footer-link-services" className="hover:text-pacces-gold transition-colors" href="/#services">Serviços</a>
                        <a id="footer-link-privacy" className="hover:text-pacces-gold transition-colors" href="/privacidade">Privacidade</a>
                        {/* Acesso interno do escritório. Fica no rodapé e com este rótulo
                            de propósito: um "Portal" em destaque na vitrine faz o cliente
                            que chegou procurando advogado clicar achando que é dele.
                            `rel="nofollow"` porque /portal é noindex — o link existe para
                            quem tem senha, não para o rastreador seguir. */}
                        <a
                            id="footer-link-portal"
                            className="hover:text-pacces-gold transition-colors"
                            rel="nofollow"
                            href="/portal"
                        >
                            Acesso restrito
                        </a>
                    </nav>
                </div>

            </div>
        </footer>
    );
};
